// const API_URL = "https://api.spacexdata.com/v4";
//production
const API_URL = "https://api.ebels.app/api";
//local
//const API_URL = "http://localhost:8000/api";
export default API_URL;
